import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            平台优势
          </h2>
          <p className="text-sm text-foreground-500 mt-1">为什么选择天狼影院</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featuresData.map((feature, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-background-200 p-5 md:p-6 text-center hover:border-primary-200 transition-colors cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-xl bg-primary-100">
                <i className={`${feature.icon} text-primary-500 text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}